import React from "react";

export const DownloadJsonIcon = ({ size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    <g fill={color}>
      <path
        d="m19,22H5c-1.654,0-3-1.346-3-3v-4h2v4c0,.551.449,1,1,1h14c.551,0,1-.449,1-1v-4h2v4c0,1.654-1.346,3-3,3Z"
        strokeWidth="0"
        fill={color}
      />
      <polygon
        points="17 8.586 13 12.586 13 2 11 2 11 12.586 7 8.586 5.586 10 12 16.414 18.414 10 17 8.586"
        fill={color}
        strokeWidth="0"
      />
    </g>
  </svg>
);
